import * as React from "react";

import { clamp } from "../../../../../Common/IntRangeUtils";

import { ProgressBarActive, ProgressBarBackground } from "./ProgressBar.styles";

interface ProgressBarProps {
    progress: number;
}

export const ProgressBar = (props: ProgressBarProps) => (
    <ProgressBarBackground>
        <ProgressBarActive style={{ width: `${clamp(props.progress, 0, 100)}%` }} />
    </ProgressBarBackground>
);
